import React, { useMemo } from 'react';
import { HistoryActionT } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'next-i18next';
import { IActivityStatusLocale } from 'src/features/common/activity/types/locales';
import { theme } from 'src/features/common/app/components/theme-provider/theme';
import { StyledWrapper } from 'src/features/common/activity/components/activity-label/styles';

export const ActivityLabel: React.VFC<{ type: HistoryActionT }> = ({ type }) => {
    const { t } = useTranslation(['components']);

    const locale: IActivityStatusLocale = useMemo(() => (
        t('activities.type', { returnObjects: true })
    ), [t]);

    const typeColors = useMemo<Partial<Record<HistoryActionT, string>>>(() => ({
        Buying: theme.colors.green500,
        Bid: theme.colors.green500,
        BidMultipleCollectable: theme.colors.green500,
        BuyingMultipleCollectable: theme.colors.green500,
        OnSale: theme.colors.green500,
        OnSaleMultipleCollectable: theme.colors.green500,
    }), []);

    return (
        <StyledWrapper style={{ color: typeColors[type] }}>
            {locale[type]}
        </StyledWrapper>
    );
};
